// components/admin/quotes/QuoteFilters.jsx
import { Search, Filter } from 'lucide-react';

export default function QuoteFilters({ filters, onFilterChange, loading }) {
  const statusOptions = [
    { value: 'all', label: 'Tous' },
    { value: 'pending', label: 'En attente' },
    { value: 'sent', label: 'Envoyés' },
    { value: 'accepted', label: 'Acceptés' },
    { value: 'declined', label: 'Refusés' },
    { value: 'expired', label: 'Expirés' }
  ];
  
  const sortOptions = [
    { value: 'createdAt', label: 'Date de création' },
    { value: 'updatedAt', label: 'Date de modification' },
    { value: 'total', label: 'Montant' },
    { value: 'clientName', label: 'Nom client' }
  ];
  
  return (
    <div className="filters-section">
      <div className="search-container">
        <div className="search-box">
          <Search size={20} />
          <input
            type="text"
            placeholder="Rechercher un client, projet, email..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
      
      <div className="filters-row">
        <div className="filter-group">
          <label><Filter size={16} /> Statut:</label>
          <div className="status-filters">
            {statusOptions.map(({ value, label }) => (
              <button
                key={value}
                className={`filter-btn ${filters.status === value ? 'active' : ''}`}
                onClick={() => onFilterChange('status', value)}
                disabled={loading}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        
        <div className="filter-group">
          <label>Trier par:</label>
          <select
            value={filters.sortBy}
            onChange={(e) => onFilterChange('sortBy', e.target.value)}
            className="sort-select"
            disabled={loading}
          >
            {sortOptions.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
          
          <button
            className="sort-order-btn"
            onClick={() => onFilterChange('sortOrder', filters.sortOrder === 'asc' ? 'desc' : 'asc')}
            disabled={loading}
          >
            {filters.sortOrder === 'asc' ? '↑' : '↓'}
          </button>
        </div>
      </div>
    </div>
  );
}